<template>
  <v-content>
    <v-container>
      <v-layout text-xs-center wrap>
        <v-flex xs12>
          <v-autocomplete
            class="mb-3"
            v-model="selectedAuditSample"
            :items="auditSamples"
            item-text="doctor"
            item-value="id"
            label="Location Visited"
            @change="checkHasSignatureText()"
          ></v-autocomplete>
          <v-text-field v-model="signerName" label="Signatory"></v-text-field>
          <div class="text-center" v-if="hasSignatureText">
            <h2>Signature Notes:</h2>
            <div class="signatureText" v-html="signatureText"></div>
          </div>

          <v-layout pa-2 row justify-center>
            <VueSignaturePad class="signatureBox" width="500px" height="200px" ref="signaturePad" />
          </v-layout>
          <div class="text-center">
            <v-btn class="primary" @click="save">Save</v-btn>
            <v-btn class="ml-4 warning" @click="undo">Undo</v-btn>
            <v-btn class="ml-4 error" @click="clear">Clear</v-btn>
          </div>

          <v-snackbar
            v-model="successSnackbar"
            color="success"
            :multi-line="true"
            :timeout="5000"
            :vertical="true"
          >
            Successfully submitted signature!
            <v-btn dark text @click="successSnackbar = false"></v-btn>
          </v-snackbar>

          <v-snackbar
            v-model="failureSnackbar"
            color="failure"
            :multi-line="true"
            :timeout="10000"
            :vertical="true"
          >
            {{failureMessage}}
            <v-btn dark text @click="failureSnackbar = false"></v-btn>
          </v-snackbar>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  name: "Signature",
  data: () => ({
    auditSamples: [],
    selectedAuditSample: "",
    signerName: "",
    failureSnackbar: false,
    failureMessage: "",
    successSnackbar: false,
    hasSignatureText: false,
    signatureText: null
  }),
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    }
  },
  created() {
    this.getAuditSamples(this.$route.query.q);
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.failureSnackbar = true;
        this.failureMessage = "Please sign the form!";
        return;
      }
      if (
        this.selectedAuditSample.length === 0 ||
        this.signerName.length === 0
      ) {
        this.failureSnackbar = true;
        this.failureMessage = "Please fill out the whole form!";
        return;
      }
      this.submitSignature(data);
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    getAuditSamples(q) {
      let config = {
        url: `${this.getBaseUrl}/signature/auditSamplesByAuditorID/${this.$route.params.id}`,
        method: "GET"
      };

      axios(config)
        .then(response => {
          if (response.status === 200) {
            this.auditSamples = response.data;
            // Redirect to home if no samples
            if (this.auditSamples.length === 0) {
              this.$router.push("/");
            }

            // Filter sign box if there is a query param
            if (typeof q !== "undefined") {
              this.auditSamples = _.remove(this.auditSamples, function(n) {
                return n.id == q;
              });
            }
            for (let auditSample of this.auditSamples) {
              if (typeof q !== "undefined") {
                if (auditSample.id == q) {
                  auditSample.doctor =
                    auditSample.doctorName + " at " + auditSample.doctorAddress;
                }
              } else {
                auditSample.doctor =
                  auditSample.doctorName + " at " + auditSample.doctorAddress;
              }
            }
            // Select first item if only one
            if (this.auditSamples.length === 1) {
              this.selectedAuditSample = this.auditSamples[0].id;
              this.checkHasSignatureText();
            }
          } else {
            this.$router.push("/");
          }
        })
        .catch(err => {
          console.log(err);
          this.$router.push("/");
        });
    },
    clearForm() {
      this.clear();
      this.signerName = "";
      this.selectedAuditSample = "";
    },
    submitSignature(signData) {
      let config = {
        url: `${this.getBaseUrl}/signature`,
        method: "POST",
        data: {
          signData,
          selectedAuditSample: this.selectedAuditSample,
          signerName: this.signerName
        }
      };

      axios(config)
        .then(response => {
          if (response.status === 201) {
            this.clearForm();
            this.successSnackbar = true;
          } else {
            this.failureSnackbar = true;
            this.failureMessage = "Error submitting!";
          }
        })
        .catch(err => {
          console.log(err);
          this.failureSnackbar = true;
          this.failureMessage = "Error submitting!";
        });
    },
    checkHasSignatureText() {
      for (let auditSample of this.auditSamples) {
        if (auditSample.id == this.selectedAuditSample) {
          if (auditSample.signatureText !== null) {
            if (auditSample.signatureText.length > 0) {
              this.signatureText = auditSample.signatureText;
              this.hasSignatureText = true;
              return;
            }
          }
        } else {
          this.signatureText = null;
          this.hasSignatureText = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.signatureBox {
  border-style: solid;
  border-width: 2px;
}
.signatureText {
  font-size: 175%;
}
</style>